export const MAX_VIDEO_FILE_SIZE = 4000000;
